import { Icon } from "@chakra-ui/react"
import { useEffect, useState } from "react"
import { FaAngleDown, FaAngleUp } from "react-icons/fa"

interface SortProps {
  columnNamePassed?: string
  orderByPassed: string
}


function Sort({ columnNamePassed, orderByPassed }: SortProps) {
  useEffect(() => {
    if (columnNamePassed !== undefined) {
      sortTable()
    }
  }, [columnNamePassed, orderByPassed])

  const [isSorted, setIsSorted] = useState(false)

  const sortTable = () => {
    switch (orderByPassed) {
      case "":
        setIsSorted(false)
        break
      case "desc":
        setIsSorted(true)
        break
      case "asc":
        setIsSorted(true)
        break
    }
  }

  return isSorted &&
    orderByPassed == "desc" ? (
      <Icon
        as={FaAngleDown}
        verticalAlign="text-bottom"
        className="sortable"
        fontSize={15}
        aria-label="Absteigend sortieren"
      />
    ) : (
      <Icon
        as={FaAngleUp}
        verticalAlign="text-bottom"
        className="sortable"
        fontSize={15}
        aria-label="Aufsteigend sortieren"
      />
    )
}

export default Sort
